import { c as _c } from "react/compiler-runtime";
import { Box, Heading, Tag, Text, VStack } from '@chakra-ui/react';
import { NextLink } from '@src/components/sco/utilities/NextLink';
type PlaybookPhaseCardProps = {
  title?: string;
  href?: string;
  teaser?: string;
  badge?: string;
};
export const PlaybookPhaseCard = props => {
  const $ = _c(14);
  const {
    title,
    href,
    teaser,
    badge
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0.85
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = `${href}`;
  let t2;
  if ($[1] !== title) {
    t2 = <Heading fontSize="20px" marginBottom="0.5em">{title}</Heading>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== badge) {
    t3 = badge && <Tag.Root bg="#385564" borderRadius="2em" color="white" fontFamily="Poppins, sans-serif" fontSize="12px" fontWeight="semibold" padding="8px 12px">{badge}</Tag.Root>;
    $[3] = badge;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <VStack align="start" bgColor="colorPalette.fg/10" borderTopRadius="12px" p="63px 32px">{t2}{t3}</VStack>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== teaser) {
    t5 = <Box padding="24px 32px"><Text fontSize="15px" opacity={0.9}>{teaser}</Text></Box>;
    $[8] = teaser;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t4 || $[12] !== t5) {
    t6 = <Box asChild={true} bgColor="colorPalette.subtle" borderRadius="12px" cursor="pointer" display="block" width="100%" _hover={t0}><NextLink href={t1}>{t4}{t5}</NextLink></Box>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};